import Footer from '../b2b/Footer';
import React from 'react';

const CorporateCardEnrollmentConsent: React.FC = () => {
  return (
    <>
      <div className='container-fluid md:container md:mx-12 mb-8'>
        <section>
          <h2 className='text-[1.25rem] leading-[2rem] md:text-[40px] text-[#2D2D2D] md:leading-[40px] font-[400]'>
            Corporate Card Enrollment Consent (Bulk Upload)
          </h2>

          <div className='term mt-8'>
            <p className='text-base text-gray-700 mb-6'>
              By checking this box and uploading a file, you confirm that you are an authorized representative of the Program and you agree to the following:
            </p>

            <div className='space-y-6'>
              <div>
                <h3 className='font-bold text-lg mb-2'>
                  1. Authorization for monitoring and data sharing
                </h3>
                <p className='text-base text-gray-700'>
                  You authorize the applicable payment card network(s) to monitor the payment cards included in your upload (the "Corporate Cards") and to share purchase data as required to participate in the Program, in accordance with the{' '}
                  <a
                    href='https://members.saversapp.com/terms-and-conditions'
                    target='_blank'
                    rel='noopener noreferrer'
                    className='text-primary hover:underline font-semibold'
                  >
                    Program Terms
                  </a>
                  ,{' '}
                  <a
                    href='https://members.saversapp.com/privacy-policy'
                    target='_blank'
                    rel='noopener noreferrer'
                    className='text-primary hover:underline font-semibold'
                  >
                    Privacy Policy
                  </a>
                  , and any applicable program rules.
                </p>
              </div>

              <div>
                <h3 className='font-bold text-lg mb-2'>
                  2. Data used to enable card-linked offers and rewards
                </h3>
                <p className='text-base text-gray-700'>
                  You understand and agree that purchase data relating to Corporate Cards, including{' '}
                  <strong>date/time, purchase amount, and merchant name, location, and category</strong>, will be shared with the Program provider <strong>Olive</strong>, with <strong>Savers App</strong>, and with merchant partners that fund rewards, in order to enable card-linked offers, calculate/confirm rewards, provide notifications about reward status, and generate corporate reporting.
                </p>
              </div>

              <div>
                <h3 className='font-bold text-lg mb-2'>
                  3. Authority and member information
                </h3>
                <p className='text-base text-gray-700'>
                  You represent and warrant that you have the legal authority to enrol the Corporate Cards and to provide the associated employee/member registration information (name, phone number, email). You further represent and warrant that you have provided (or will provide) any required notices and obtained any necessary consents from the individuals whose information you submit, as required by applicable law and your internal policies.
                </p>
              </div>

              <div>
                <h3 className='font-bold text-lg mb-2'>
                  4. Reporting scope and separation of personal vs corporate activity
                </h3>
                <p className='text-base text-gray-700'>
                  You acknowledge that the Program Portal reporting will be limited to transactions and rewards associated with Corporate Cards and will not provide access to members' personal card transactions. Members may view their own personal and corporate activity in the app, as applicable.
                </p>
              </div>

              <div>
                <h3 className='font-bold text-lg mb-2'>
                  5. Duration and revocation
                </h3>
                <p className='text-base text-gray-700'>
                  This authorization remains in effect until it is revoked, including by removing/unenrolling the relevant Corporate Card(s) through the Program Portal or via other Program settings or processes. Data will be accessible until such time as authorization is revoked.
                </p>
              </div>
            </div>
          </div>
        </section>
      </div>
      <Footer />
    </>
  );
};

export default CorporateCardEnrollmentConsent;
